'use client';

import { ListingPayload, UserPackage } from './listing.type';

import { areAllPropertiesEmpty } from '@/slw/shared/lib/utils';

export function getUserPackageById(userPackages: UserPackage[], packageId: number) {
  return userPackages.find((userPackage) => userPackage.packageId === packageId);
}

export const checkVehicleStatusEmpty = (listing: ListingPayload) => {
  const vehicleStatus = {
    titleStatus: listing.titleStatus,
    transmission: listing.transmission,
    engineCondition: listing.engineCondition,
    odometer: listing.odometer,
    engineSize: listing.engineSize,
    engineHistory: listing.engineHistory,
    vehicleRestorationHistory: listing.vehicleRestorationHistory,
    vehicleRestorationHistoryExplained: listing.vehicleRestorationHistoryExplained,
  };

  return areAllPropertiesEmpty(vehicleStatus);
};

export const checkExteriorConditionEmpty = (listing: ListingPayload) => {
  const exteriorCondition = {
    exteriorColor: listing?.exteriorColor || '',
    exteriorCondition: listing?.exteriorCondition || '',
    seatMaterial: listing?.seatMaterial || '',
    interiorColor: listing?.interiorColor || '',
  };

  return areAllPropertiesEmpty(exteriorCondition);
};
